import { useState, useEffect } from "react"
import { toast } from "react-toastify"
import { getPermList, updatePermList } from "../../services/permissionsApis"
import Input from "../Input"

const Permissions = ({ user }) => {
    const [permList, setPermList] = useState(null)

    useEffect(() => {
        if (user) {
            getPermList(user.token)
                .then(({ data }) => {
                    setPermList(data)
                })
                .catch((err) => {
                    console.error(err)
                })
        }
    }, [user])
    if (!permList) {
        return (
            <>
                <h3>درحال بارگذاری...</h3>
            </>
        )
    }
    return (
        <div dir="ltr" className="w-full h-full y-scroll">
            <div dir="rtl" className="mx-14">
                <h3 className="mb-5">لیست قیمت پرمیشن های ساخت بات مدیریتی:</h3>
                <form
                    onSubmit={(event) => {
                        event.preventDefault()
                        const form = new FormData(event.target)
                        let newData = {
                            perms: {},
                        }

                        for (let i in permList) {
                            const permName = permList[i].name
                            newData.perms[permName] = form.get(permName)
                        }

                        toast
                            .promise(updatePermList(newData), {
                                pending: "درحال اپدیت قیمت پرمیشن",
                                success: "اپدیت شد",
                            })
                            .catch((err) => {
                                console.error(err)
                            })
                    }}
                >
                    {permList &&
                        permList.map((item, index) => {
                            return (
                                <div className="mb-3" key={index}>
                                    <label for={item.name} class="block mb-2 text-sm font-medium  text-gray-300">
                                        {item.desc}
                                    </label>

                                    <Input
                                        type="number"
                                        name={item.name}
                                        placeholder={item.name}
                                        defaultValue={item.price}
                                    />
                                </div>
                            )
                        })}

                    <button type="submit" className="styled-button border px-4 py-2 m-2">
                        آپدیت
                    </button>
                </form>
            </div>
        </div>
    )
}

export default Permissions
